<div class="formSection">
  <div style="display: flex; align-items: start; gap: 40px">
    <div style="flex: 1">
        <app-textbox 
          [label]="'Name'"
          [required]="true"
          [showRequired]="true"
          [(ngModel)]="this.data.name"
          [readonly]="this.mode == FormMode.View"
        ></app-textbox>
        <app-textbox 
          [label]="'Description'"
          [(ngModel)]="this.data.description"
          [readonly]="this.mode == FormMode.View"
        ></app-textbox>
    </div>
  </div>
</div>
